import ipaddr from 'ipaddr.js';

export function stripIpBrackets(hostname: string): string {
  const host = hostname.trim().toLowerCase().replace(/\.$/, '');
  if (host.startsWith('[') && host.endsWith(']')) return host.slice(1, -1);
  return host;
}

export function isIpLiteral(hostname: string): boolean {
  return ipaddr.isValid(stripIpBrackets(hostname));
}

function isIPv6(address: ipaddr.IPv4 | ipaddr.IPv6): address is ipaddr.IPv6 {
  return address.kind() === 'ipv6';
}

export function isPublicIp(address: string): boolean {
  let parsed: ipaddr.IPv4 | ipaddr.IPv6;
  try {
    parsed = ipaddr.parse(stripIpBrackets(address));
  } catch {
    return false;
  }

  if (isIPv6(parsed)) {
    if (parsed.isIPv4MappedAddress()) {
      return isPublicIp(parsed.toIPv4Address().toString());
    }
    return parsed.range() === 'unicast';
  }

  return parsed.range() === 'unicast';
}

export function canonicalPublicAddress(
  address: string,
): { address: string; family: 4 | 6 } | null {
  let parsed: ipaddr.IPv4 | ipaddr.IPv6;
  try {
    parsed = ipaddr.parse(stripIpBrackets(address));
  } catch {
    return null;
  }

  if (isIPv6(parsed) && parsed.isIPv4MappedAddress()) {
    const mapped = parsed.toIPv4Address().toString();
    if (!isPublicIp(mapped)) return null;
    return { address: mapped, family: 4 };
  }

  if (!isPublicIp(address)) return null;

  if (!isIPv6(parsed)) {
    return { address: parsed.toString(), family: 4 };
  }

  return { address: parsed.toNormalizedString(), family: 6 };
}
